/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {InputCriteriaTypeComponent} from './input-criteria-type.component';
import {InputCriteriaTextModule} from './input-criteria-text/input-criteria-text.module';
import {CommonModule} from '@angular/common';
import {InputCriteriaDateModule} from './input-criteria-date/input-criteria-date.module';
import {InputCriteriaCurrencyModule} from './input-criteria-currency/input-criteria-currency.module';
import {InputCriteriaMultiSelectionModule} from './input-criteria-multi-selection/input-criteria-multi-selection.module';
import {InputCriteriaAutocompleteMultiSelectionModule} from './input-criteria-autocomplete-multi-selection/input-criteria-autocomplete-multi-selection.module';

@NgModule({
    declarations: [
        InputCriteriaTypeComponent,
    ],
    exports: [
        InputCriteriaTypeComponent
    ],
    imports: [
        InputCriteriaTextModule,
        InputCriteriaDateModule,
        InputCriteriaCurrencyModule,
        InputCriteriaMultiSelectionModule,
        InputCriteriaAutocompleteMultiSelectionModule,
        CommonModule
    ]
})
export class InputCriteriaTypeModule {
}
